import React, { useEffect, useState } from 'react';
import { Form, FormGroup, Input, Label, Row, Col, Modal, ModalHeader, ModalBody } from 'reactstrap';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import { createTheme, MuiThemeProvider, withStyles } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const LandingPageModal = (props) => {
  const styles = (theme) => ({
    root: {
      margin: 0,
      padding: theme.spacing(2),
      width: 500,
      height: 70,
      textAlign: 'center',
    },
    closeButton: {
      position: 'absolute',
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500],
    },
  });

  const DialogTitle = withStyles(styles)((props) => {
    const { children, classes, onClose, ...other } = props;
    return (
      <MuiDialogTitle disableTypography className={classes.root} {...other}>
        <Typography variant="h6">{children}</Typography>
        {onClose ? (
          <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
            <CloseIcon />
          </IconButton>
        ) : null}
      </MuiDialogTitle>
    );
  });

  //-----Designation Modal close button toggle-----//
  const closeDeleteCheckBtn = (
    <Button type="submit" outline color="white" onClick={props.toggle}>
      <FontAwesomeIcon icon={['fas', 'times']} size="lg" />
    </Button>
  );

  return (
    <div>
      <Dialog
        className={styles.root}
        onClose={props.toggle}
        aria-labelledby="customized-dialog-title"
        open={props.isOpen}
      >
        <DialogTitle id="customized-dialog-title" onClose={props.toggle}></DialogTitle>

        <ModalBody>
          <Typography variant="h6" style={{ textAlign: 'center', fontFamily: 'Montserrat, sans-serif', marginBottom: '20px' }}>
            Thank you for your feedback!
          </Typography>
          <br></br>

          <div className="deleteUserButton">
            <Button
              block
              onClick={props.historyPagePush}
              //fullWidth="true"
              variant="contained"
              color="primary"
              style={{float: 'right'}}
            >
              Return to the Portal
            </Button>
          </div>
        </ModalBody>
      </Dialog>
    </div>
  );
};
export default LandingPageModal;